import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type SOPToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function SOPToolbar({ canManage, onCreate }: SOPToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">
            ຂັ້ນຕອນການດໍາເນີນງານ (SOP)
          </h2>
          <p className="text-muted-foreground">
            ຈັດການຂັ້ນຕອນການດໍາເນີນງານຂອງອົງກອນ.
          </p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງ SOP ໃໝ່
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
